// extracted by mini-css-extract-plugin
export default {"logoutSection":"logoutSection-sBdCz","logoutButton":"logoutButton-ifwfr","centered":"centered-QBHN1"};